import React from 'react';

import PropTypes from 'prop-types';
import './styles.css';

const ActionLink = (props) => {
   return (
      <span onClick={props.onClick} className='action-link'>
         {props.label}
      </span>
   );
};

ActionLink.propTypes = {
   label: PropTypes.string.isRequired,
   onClick: PropTypes.func.isRequired,
};

export default ActionLink;
